import React, {createElement, ReactElement} from "react";

export class FormattedNumber extends React.Component<any, any> {

    render(): ReactElement {
        let props: any = {...this.props};

        const parentNode: string = props?.parentNode || 'span';

        let value: string = '-';
        if (props.value) {

            value = FormattedNumber.format(props?.value, props?.decimals || 0, props?.decPoint || '.', props?.thousandsSep || ' ');

            if (this.props?.suffix) {
                value = value + ' ' + this.props?.suffix;
            }
        }

        props?.value && delete props?.value;
        props?.suffix && delete props?.suffix;
        props?.decimals && delete props?.decimals;
        props?.decPoint && delete props?.decPoint;
        props?.thousandsSep && delete props?.thousandsSep;
        props?.parentNode && delete props?.parentNode;

        return createElement(parentNode, props, value);
    }

    static formatIf(number: any, decimals: number = 0, zeroCharacter: null | string = '-', decPoint: string = '.', thousandsSep: string = ' '): string {
        return FormattedNumber.format(number, decimals, decPoint, thousandsSep, zeroCharacter);
    }

    static format(number: any, decimals: number = 0, decPoint: string = '.', thousandsSep: string = ' ', zeroCharacter: null | string = null): string {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
        number = !isFinite(+number) ? 0 : +number;

        if (typeof zeroCharacter === 'string'
            && number === 0) {
            return zeroCharacter;
        }

        const precision: number = !isFinite(+decimals) ? 0 : Math.abs(decimals);

        const toFixedFix: any = function (n: any, precision: any) {
            const k = Math.pow(10, precision);
            return '' + (Math.round(n * k) / k).toFixed(precision)
        }

        let strValue: string[] = (precision ? toFixedFix(number, precision) : '' + Math.round(number)).split('.')

        if (strValue[0].length > 3) {
            strValue[0] = strValue[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSep)
        }
        if ((strValue[1] || '').length < precision) {
            strValue[1] = strValue[1] || ''
            strValue[1] += new Array(precision - strValue[1].length + 1).join('0')
        }
        return strValue.join(decPoint)
    }
}
